import React from 'react';
import { Shield, CheckCircle, FileCheck, Users, BarChart, Settings } from 'lucide-react';

const iconMap = {
  shield: Shield,
  check: CheckCircle,
  file: FileCheck,
  users: Users,
  chart: BarChart,
  settings: Settings,
};

const FeatureCard = ({ 
  title = 'Feature Title',
  description = 'Feature description explaining the benefit',
  icon = 'shield',
  className = '' 
}) => {
  const Icon = iconMap[icon] || Shield;

  return (
    <div className={`p-6 bg-card border border-border rounded-lg ${className}`}>
      <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-primary" />
      </div>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground text-sm">{description}</p>
    </div>
  );
};

FeatureCard.builderConfig = {
  props: {
    title: {
      type: 'text',
      label: 'Title',
      default: 'Feature Title',
    },
    description: {
      type: 'textarea',
      label: 'Description',
      default: 'Feature description explaining the benefit',
    },
    icon: {
      type: 'select',
      label: 'Icon',
      default: 'shield',
      options: [
        { value: 'shield', label: 'Shield' },
        { value: 'check', label: 'Check Circle' },
        { value: 'file', label: 'File Check' },
        { value: 'users', label: 'Users' },
        { value: 'chart', label: 'Chart' },
        { value: 'settings', label: 'Settings' },
      ],
    },
  },
};

export default FeatureCard;
